import React from "react";
import { Container } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import i18n from "utils/I18n";

import { TickIcon } from "component/base/SvgIcons";
import { languageList } from "component/common/navigator/SelectLanguage";
import { createAction } from "utils";
import "./LanguagesSelection.scss"

const LanguagesSelection = ({
  language
}) => {
  const dispatch = useDispatch();

  const changeLanguage = (lang) => {
    if (language===lang) {
      return
    }
    i18n.changeLanguage(lang).then(()=> {
      dispatch(createAction("users/updateState")({ language: lang }))
      dispatch(createAction("users/updateDisplayName")())
    });
  };
  return (
    <Container>
      <div className="languages-page-container">
        <div className="common-section-title title-medium-2">
          {i18n.t("settings_language")}
        </div>
        <div className="field-text">
          {languageList?.map((langItem) =>
            <div className="lanuage-selection-item" onClick={() => changeLanguage(langItem?.value)}>
              <div>{langItem?.name}</div>
              {language === langItem?.value ? 
                <TickIcon /> : null
              }
            </div>
          )}
        </div>
      </div>
    </Container>
  )
}

const mapPropsToState = (state) => ({
  language: state.users.language,
});

export default connect(mapPropsToState)(LanguagesSelection);